var React = require('react');

function Institution (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M832 0l960 384v128h-128q0 26-20.5 45t-48.5 19H69q-28 0-48.5-19T0 512h-128V384zM128 640h256v768h128V640h256v768h128V640h256v768h128V640h256v768h59q28 0 48.5 19t20.5 45v64H0v-64q0-26 20.5-45t48.5-19h59V640zm1595 960q28 0 48.5 19t20.5 45v128H-128v-128q0-26 20.5-45t48.5-19h1782z"}));
}

Institution.defaultProps = {"width":"1792","height":"1792","viewBox":"0 0 1792 1792"};

module.exports = Institution;

Institution.default = Institution;
